/* eslint-disable */
import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

//Styles
import "./SideMenu.scss";

//assets
import Burger from "../../../assets/images_delete/burger.jpg";
import menuData from "../../../assets/jsons/sideMenu.json";
import Close from "../../../assets/icons/sideMenu/icon_menu_cerrar_act.png";
import iconHamburguesa from "../../../assets/icons/sideMenu/icono_menu_desplegable_act.png";

//Utilities
import { useAuthStore, useStoreRt } from "../../../zustand/ZustandContext.jsx";
import { userLogout } from "../../../services/Auth.js";
import { toast } from "sonner";
import LogoutModal from "../../molecules/LogoutModal/LogoutModal";

const SideMenu = ({ className }) => {
    const local = useLocation();
    const logout = useAuthStore((state) => state.logout);

    //useStore
    const { openAside, setOpenAside, setOverAside, overAside, imageSett } =
        useStoreRt();

    //States para el estado del movil
    const [sideMovil, setSideMovil] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    // Función para determinar si una ruta del menú está activa
    const isRouteActive = (menuUrl) => {
        const currentPath = local.pathname;

        // Mapeo de rutas relacionadas
        const routeRelations = {
            "/business-list": ["/business-list", "/editar-negocio"],
            "/list-plans": ["/list-plans", "/editar-plan"],
            "/crear-nuevo-negocio": ["/crear-nuevo-negocio"],
            "/business-payments": ["/business-payments"],
            "/inicio": ["/inicio"],
            "/proveedores": ["/proveedores"],
        };

        // Si la ruta tiene relaciones, verificar si la ruta actual coincide
        if (routeRelations[menuUrl]) {
            return routeRelations[menuUrl].some((route) =>
                currentPath.startsWith(route)
            );
        }

        // Para rutas sin relaciones, hacer comparación exacta
        return currentPath === menuUrl;
    };

    const handleLogoutClick = () => {
        setShowLogoutModal(true);
    };

    const handleCancelLogout = () => {
        setShowLogoutModal(false);
    };

    const handleConfirmLogout = async () => {
        setIsLoggingOut(true);

        try {
            // Llamar al servicio de logout
            const response = await userLogout();

            // Mostrar toast de éxito
            toast.success("¡Hasta pronto!", {
                description: "Tu sesión se cerró de forma segura",
                duration: 3000,
                icon: "👋",
            });

            // Pequeña espera para que el usuario vea el mensaje
            await new Promise((resolve) => setTimeout(resolve, 800));

            // Cerrar modal
            setShowLogoutModal(false);

            // Ejecutar logout en el store (redirige al login)
            await logout();
        } catch (error) {
            console.error("Error en logout:", error);

            // Incluso si hay error en el servidor, limpiar sesión local
            toast.error("Sesión cerrada localmente", {
                description:
                    "Hubo un problema con el servidor, pero tu sesión local se limpió",
                duration: 4000,
            });

            // Esperar un poco y hacer logout de todas formas
            await new Promise((resolve) => setTimeout(resolve, 1000));
            setShowLogoutModal(false);
            await logout();
        } finally {
            setIsLoggingOut(false);
        }
    };

    const handleAsideComplete = () => {
        if (window.innerWidth > 767) {
            setOpenAside(!openAside);
        } else {
            setSideMovil(!sideMovil);
        }
    };

    const handleEntry = () => {
        if (!openAside && window.innerWidth > 767) {
            setOverAside(true);
        }
    };

    const handleLeave = () => {
        if (!openAside && window.innerWidth > 767) {
            setOverAside(false);
        }
    };

    useEffect(() => {
        if (sideMovil) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }
    }, [sideMovil]);

    const handleHidenSide = () => {
        setSideMovil(false);
    };

    return (
        <>
            <aside className={`Aside ${className} `}>
                <div
                    className={`aside-inside ${openAside ? "aside-open" : ""} ${
                        overAside ? "aside-open-over" : ""
                    } ${sideMovil ? "show-aside-movil" : ""}`}
                >
                    <div
                        className={`a-cnt-btn ${
                            openAside ? "a-cnt-move-btn" : ""
                        } 
                        ${overAside ? "a-cnt-move-btn-over" : ""} ${
                            sideMovil ? "a-cnt-movil-bnt" : ""
                        }`}
                    >
                        <button
                            className={`btn-close-side`}
                            onClick={handleAsideComplete}
                        >
                            <img
                                src={iconHamburguesa}
                                alt=""
                                className="icon-abur"
                            />
                        </button>
                    </div>
                    <div
                        className={`container-aside`}
                        onMouseEnter={handleEntry}
                        onMouseLeave={handleLeave}
                    >
                        <div
                            className={`cnt-banner ${
                                openAside ? "cnt-open-banner" : ""
                            } ${overAside ? "cnt-open-banner" : ""}`}
                        >
                            <img
                                // src="https://cdn-icons-png.flaticon.com/512/5277/5277459.png"
                                src={imageSett ? imageSett : Burger}
                                alt=""
                                className={`ban-logo ${
                                    openAside ? "ban-open-logo" : ""
                                } ${overAside ? "ban-open-logo" : ""}`}
                            />
                        </div>
                        <div className={`cnt-options`}>
                            <ul className={`o-lu`}>
                                {menuData.map((_, idx) => (
                                    <li
                                        key={idx}
                                        className={`o-li`}
                                        onClick={handleHidenSide}
                                    >
                                        <NavLink
                                            to={_.url}
                                            className={`o-nav ${
                                                isRouteActive(_.url)
                                                    ? "active"
                                                    : ""
                                            } `}
                                        >
                                            <img
                                                src={require(`../../../assets/icons/sideMenu/${_.icon}`)}
                                                alt=""
                                                className={`o-img ${
                                                    isRouteActive(_.url)
                                                        ? "active_image"
                                                        : ""
                                                }`}
                                            />
                                            <span
                                                className={`opt-menu-sp ${
                                                    openAside
                                                        ? "o-opa-menu"
                                                        : ""
                                                } ${
                                                    overAside
                                                        ? "o-opa-menu"
                                                        : ""
                                                }`}
                                            >
                                                {_.title}
                                            </span>
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                            <button
                                className="btn-logOut"
                                onClick={handleLogoutClick}
                            >
                                <img src={Close} alt="Cerrar sesión" />
                                <span
                                    className={`b-span ${
                                        openAside ? "b-span-opa" : ""
                                    } ${overAside ? "b-span-opa" : ""}`}
                                >
                                    CERRAR SESIÓN
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </aside>

            <LogoutModal
                isOpen={showLogoutModal}
                onConfirm={handleConfirmLogout}
                onCancel={handleCancelLogout}
                isLoading={isLoggingOut}
            />
        </>
    );
};
export default SideMenu;
